// useNivelesPreguntas.js
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const useNivelesPreguntas = () => {
  // Estados para manejar niveles, preguntas, errores y contenido multimedia
  const [niveles, setNiveles] = useState([]);
  const [preguntasNivel, setPreguntasNivel] = useState([]);
  const [nivelSeleccionado, setNivelSeleccionado] = useState(null);
  const [error, setError] = useState('');
  const [showMultimedia, setShowMultimedia] = useState(false);
  const [multimediaUrl, setMultimediaUrl] = useState('');
  const [multimediaType, setMultimediaType] = useState('');
  const [file, setFile] = useState(null);
  const {temaId} = useParams();
  // Efecto para cargar los niveles al montar el componente
  useEffect(() => {
    const fetchNiveles = async () => {
      try {
        const token = localStorage.getItem('token');
        console.log(token)
        const response = await axios.get(`${API_BASE_URL}/api/niveles`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        setNiveles(response.data);
      } catch (error) {
        console.error('Error al obtener niveles:', error);
        setError('Error al cargar los niveles. Por favor, recarga la página.');
      }
    };
    fetchNiveles();
  }, []);

  // Maneja el clic en un nivel, cargando sus preguntas y contenido multimedia
  const handleNivelClick = async (nivelId) => {
    setNivelSeleccionado(nivelId);
    setError('');
    setMultimediaUrl('');
    setMultimediaType('');
    try {
      const token = localStorage.getItem('token');
      const [preguntasResponse, multimediaResponse] = await Promise.all([
        axios.get(`${API_BASE_URL}/api/preguntas/nivel/${nivelId}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        }),
        axios.get(`${API_BASE_URL}/api/niveles/contenido-multimedia/${nivelId}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        })
      ]);

      setPreguntasNivel(preguntasResponse.data);

      if (multimediaResponse.data && multimediaResponse.data.url) {
        setMultimediaUrl(`${multimediaResponse.data.url}?t=${new Date().getTime()}`);
        const fileExtension = multimediaResponse.data.url.split('.').pop().toLowerCase();
        setMultimediaType(['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension) ? 'image' : 'video');
      } else {
        setMultimediaUrl('');
        setMultimediaType('');
      }
    } catch (error) {
      console.error('Error al obtener datos del nivel:', error);
      setError('Error al cargar los datos del nivel. Por favor, intenta de nuevo.');
    }
  };

  // Elimina una pregunta del nivel seleccionado
  const handleEliminarPregunta = async (preguntaId) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_BASE_URL}/api/preguntas/${preguntaId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setPreguntasNivel(preguntasNivel.filter(pregunta => pregunta.id !== preguntaId));
    } catch (error) {
      console.error('Error al eliminar pregunta:', error);
      setError('Error al eliminar la pregunta. Por favor, intenta de nuevo.');
    }
  };

  // Maneja el cambio de archivo seleccionado
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  // Sube el archivo de contenido multimedia al nivel seleccionado
  const handleUpload = async () => {
    if (!file) {
      setError('Por favor, selecciona un archivo primero.');
      return;
    }

    const formData = new FormData();
    formData.append('contenido_multimedia', file);

    try {
      const token = localStorage.getItem('token');
      await axios.put(`${API_BASE_URL}/api/niveles/${temaId}/contenido-multimedia`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      handleNivelClick(temaId);
      setError('');
      setFile(null);
    } catch (error) {
      console.error('Error al subir el archivo:', error);
      setError('Error al subir el archivo. Por favor, intenta de nuevo.');
    }
  };

  // Retorna los estados y funciones necesarios
  return {
    niveles,
    preguntasNivel,
    nivelSeleccionado,
    error,
    showMultimedia,
    multimediaUrl,
    multimediaType,
    file,
    handleNivelClick,
    handleEliminarPregunta,
    handleFileChange,
    handleUpload,
    setShowMultimedia,
    setError
  };
};

export default useNivelesPreguntas;